module.exports = __webpack_public_path__ + "img/browse-vehicles-three-tabs-navy.8f9c289b.png";